import { OrderResponse } from '../../../../shared/models/orders/order-response/order-response.model';
import { OrderResponseHeader } from '../../../../shared/models/orders/order-response/order-response-header.model';
import { Component, Inject, } from '@angular/core';
import { TresciService } from 'src/app/tresci.service';
import { ModalForEnum } from 'src/app/shared/enums/modal-for-enum';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslationEnum } from 'src/app/shared/enums/translation-enum';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from 'src/app/module-login/authorization.service';



interface DialogData {
  data: OrderResponseHeader;
  modalForEnum: ModalForEnum;
}

@Component({
  selector: 'app-order-response-dialog',
  templateUrl: './order-response-dialog.component.html',
  styleUrls: ['./order-response-dialog.component.scss']
})
export class OrderResponseDialogComponent   {

  public TranslationEnum = TranslationEnum;
  public Culture = '';
  canOrderButton: boolean = false;

  modalForEnum = ModalForEnum;
  dataSource: MatTableDataSource<OrderResponse> = new MatTableDataSource<OrderResponse>();

  displayedColumns: string[] = [
    'B2BId', 'Product', 'System', 'ValNetBrut', 'Ordered'
  ];
  User: import("d:/git/code/B2BAngular/src/app/shared/models/user/user.model").User;

  constructor(public dialogRef: MatDialogRef<OrderResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: DialogData, public tresci: TresciService,private router: Router, private route: ActivatedRoute,private authorizationService: AuthorizationService) {
    this.dataSource.data = dataDialog.data.OrderedStatusList;
    this.Culture = window['culture'];
    this.authorizationService.User.subscribe((user) => {
      this.User = user;
    })
     if(this.User.IsTrader){
       // this.canOrderButton  = true;
      } else {
       // this.canOrderButton = authorizationService.hasCredential(CredentialEnum.MożeZamawiać);
      }
  }
  routeTo(site: string) {
    // console.log("site", site);
    this.dialogRef.close();
    this.router.navigate([`${site}`]);
    setTimeout(() => { window.location.reload(); }, 100);
  }

}
